enum FeatureFlag {
    CheckRewardPackage = 'CheckRewardPackage',
    RetailCardRewardPackage = 'RetailCardRewardPackage',
    ClaimImport = 'ClaimImport',
    PointsRewardPackage = 'PointsRewardPackage',
    Leaderboards = 'Leaderboards',
    ProgressiveWebApp = 'ProgressiveWebApp',
    LedgerBalanceImport = 'LedgerBalanceImport',
    CustomerImport = 'CustomerImport',
    EnableReloadableCanVisaCard = 'EnableReloadableCanVisaCard',
    PortalBulkClaimImport = 'PortalBulkClaimImport',
    PortalTierSets = 'PortalTierSets',
    ReviewInformation = 'ReviewInformation',
    IsRequireCertifiedAddressesFeatureFlag = 'IsRequireCertifiedAddressesFeatureFlag',
}

export default FeatureFlag;
